// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3Peb5MyB flex","logo":"_1LpWW_Ph","button":"bxBBfyu0 flex flex-auto items-center justify-center bold"};